<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex justify-content-between w-100 p-3">
        <h5 style="font-size: 1vw !important"> ریشه علل مسئله/ {{$route.params.title}} </h5>
        <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
      </div>
      <div class="d-flex justify-content-end">

        <div class="d-flex" v-if="allItems.length">
          <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1"  v-if="modalMessage &&  allItems.length" @click="modalMessageShowModal=true">   دلایل عدم تایید</a>


<!--          <a   :href="`${this.download_url}/rootCauses/all/pdf/by/id/${id_route}?token=${$cookies.get('id_login')}`"
             style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
            PDF</a>-->

        </div>

      </div>
      <center>
        <div class="alert alert-info" style="width: 10vw;" v-if="modalMessage && !allItems.length" @click="modalMessageShowModal=true">دلایل عدم تایید</div>
        <div dir="rtl" class="modal__error slide-top" v-show="modalMessageShowModal" style="z-index: 999999999999999; top: 40%;">
          <div>
            <p>دلایل عدم تایید</p>
            <p @click="modalMessageShowModal=!modalMessageShowModal">❌</p>
          </div>
          <div>
            <div class="bg-white w-100 rounded p-3 text-right">
              <p>{{modalMessageShow}}</p>
            </div>

            <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
              <button @click="modalMessageShowModal=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
            </div>
          </div>
        </div>
      </center>
      <div class="table-responsive p-5">
         <center v-if="!allItems.length">
          در انتظار تکمیل / بروزرسانی کاربرگ توسط {{$route.params.title}}
        </center>
        <center v-else>
           <div v-if="status_show" class="alert alert-success">
            تایید نهایی   شرکت {{$route.params.title}} انجام شد
          </div>
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table v-show="allItems.length" class="table table-striped bg-white" >
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>


            <th rowspan="2"><strong>مسئله
              (به ترتیب اولویت)
            </strong></th>
            <th rowspan="2" ><strong>     روش ریشه‌یابی </strong></th>
            <th style="width: 4vw;"><strong>عوامل ریشه‌ای</strong></th>

          </tr>
          <tr>



          </tr>
          <tr  v-for="(item,index) in allItems">
            <td style="width: 1vw;">{{index+1}}</td>
            <td>{{item.problem_identifications && item.problem_identifications.title}}  </td>
            <td style="width: 11vw;">

              <select   :value="item.root_causes_problem && item.root_causes_problem.method"  name="" :id="`method_${item.id}`" class="form-select">
                    <option value="RCA+"> RCA+</option>
                <option value="RCA"> RCA</option>
                <option value="استخوان ماهی">استخوان ماهی</option>
                <option value="  تحلیل علت و معلولی">  تحلیل علت و معلولی</option>
                <option value=" 5 چرا"> 5 چرا</option>
                <option value="سایر">سایر</option>

              </select>
            </td>
            <td>
              <button @click="modalSaveModal(item.id)" class="btn btn-primary btn-submit-1"> مشاهده </button>
            </td>





          </tr>


          </tbody>
        </table>

      </div>
        <center>
          <button
              v-show="allItems.length"
              @click="store"
              style="margin-top: 1.3vw;margin-left: 2vw;  margin-bottom: 1vw;" class="btn btn-primary btn-submit-1">ذخیره
          </button>
        </center>
        <hr v-if="allItems.length">
        <div v-if="allItems.length" class="d-flex align-items-center justify-content-center mb-3">
          <a   :href="`${this.download_url}/rootCauses/all/word/by/id/${id_route}?token=${$cookies.get('id_login')}`" style="margin-left: 1vw;margin-top: 1.3vw;"
               class="btn btn-primary btn-submit-1">خروجی Word</a>
          <p @click.prevent="exportDocs"   style="margin-left: 1vw;margin-top: 2.5vw;"
             class="btn btn-primary btn-submit-1">خروجی مستندات</p>
          <a    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green " class="btn btn-primary btn-submit-1 "

                @click="acceptComplete"
          >
            <div v-if="!status_loading">

              <span  >  تایید </span>
            </div>
            <div v-else>
              <div class="loader-line"></div>

            </div>
          </a>
          <a     style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  " class="btn btn-primary btn-submit-1 "
                 @click="acceptComplete2"
          >
            <div v-if="!status_loading2">
              <span >عدم تایید</span>
            </div>

            <div v-else>
              <div class="loader-line"></div>

            </div>
          </a>
        </div>

      </div>
      <center>

      </center>

    </div>
  </div>
  <div v-show="modalSave" class="modal__error slide-top" style="width: 50vw; z-index: 9999">
    <div class="d-flex justify-content-between flex-row-reverse"  >
      <p>عوامل ریشه ای</p>
      <p @click="modalSave=!modalSave">❌</p>
    </div>
    <div class="d-flex flex-row-reverse align-items-center justify-content-center" >
      <div class="d-flex flex-column align-items-end" style="width: 36vw;">
        <label class="required">عامل ریشه ای</label>
        <input v-model="title_root"  type="text" class="form-control text-right">
      </div>
      <div class="d-flex flex-column align-items-end mx-2 " style="width: 29vw;">
        <label class="required">    نوع</label>
        <select v-model="type_root"  class="form-select text-right">
          <option value="بازدارنده">بازدارنده</option>
          <option value="پیشران">پیشران</option>
        </select>
      </div>

    </div>
    <br>
    <div  class="d-flex flex-row-reverse align-items-center justify-content-center">
      <div class="d-flex  align-items-center  " style="width: 12vw;">
        <label  class="d-flex flex-row align-items-center">    نیروی انسانی
          <input :value="1" v-model="is_human_root" :checked="is_human_root" type="checkbox" class="form-check mt-1 mx-2 ">
        </label>


      </div>
      <div  class="d-flex  align-items-center mx-2 " style="width: 12vw;">
        <label class="d-flex flex-row align-items-center">    سرمایه
          <input :value="1" v-model="money_root" :checked="money_root" type="checkbox" class="form-check mt-1 mx-2">

        </label>

      </div>
      <div  class="d-flex  align-items-center mx-2 " style="width: 12vw;">
        <label class="d-flex flex-row align-items-center">    فناوری

          <input :value="1" v-model="tech_root" :checked="tech_root" type="checkbox" class="form-check mt-1 mx-2">
        </label>

      </div>
      <div class="d-flex  align-items-center mx-2 " style="width: 12vw;">
        <label class="d-flex flex-row align-items-center">    مدیریت
          <input :value="1" v-model="management_root" :checked="management_root" type="checkbox" class="form-check mt-1  mx-2">

        </label>

      </div>
    </div>
    <br>
    <div  class="d-flex flex-column align-items-end" style="width: 100%;">
      <label>سایر    </label>
      <input v-model="other_root"   type="text" class="form-control text-right">
    </div>
    <br>
    <center >
      <button v-if="!is_update" @click.prevent="store_root(id_root)" class="btn btn-primary btn-submit-1"> ذخیره </button>

      <div class="d-flex align-items-center justify-content-center" v-else>
        <button  @click.prevent="update(id_item)" style="margin-top: 1.3vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ویرایش</button>
        <Reset @click.prevent="resetItems" style="width: 1.5vw; height: 1.5vw; transform: translateY(0.5vw); cursor: pointer; margin-right: 1vw;" />
      </div>
    </center>
    <br>
    <hr >
    <br>
    <div style="overflow-y: scroll; height: 14vw;">
      <table v-if="allItemsOther.length" style="direction: rtl;"  class="table table-striped bg-white" >
        <thead style="height: 1vw;">
        <tr>
          <th rowspan="2"><strong>ردیف</strong></th>
          <th rowspan="2"><strong>
            عامل ریشه ای
          </strong></th>
          <th rowspan="2" ><strong>     نوع   </strong></th>
          <th><strong>   نیروی انسانی  </strong></th>
          <th><strong>   سرمایه  </strong></th>
          <th><strong>  فناوری    </strong></th>
          <th><strong>   مدیریت  </strong></th>
          <th><strong>   سایر  </strong></th>
          <th ><strong>   عملیات  </strong></th>

        </tr>

        </thead>
        <tr   v-for="(item, index) in allItemsOther">
          <td>{{index+1}}</td>
          <td>{{item.title}}</td>
          <td>{{item.type}}</td>
          <td>{{item.is_human ? '✅':''}}</td>
          <td>{{item.is_fund ? '✅':''}}</td>
          <td>{{item.is_technology ? '✅':''}}</td>
          <td>{{item.is_management ? '✅':''}}</td>
          <td>{{item.other}}</td>
          <td >
            <div class="d-flex justify-content-evenly">
              <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
              <a @click.prevent="deleteMethod(item.id)"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
              <a title="مستندات" @click.prevent="AddDocumentMethod(item.id,item.title)"   href="#"><img  class="table-delete-img" src="/img/upload_icon.jpg" alt="delete"></a>

            </div>
          </td>

        </tr>
      </table>
      <center v-else>
        موردی یافت نشد
      </center>
    </div>

    <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
      <div class="d-flex justify-content-between w-100">
        <p>حذف</p>
        <p @click="deleteModal=!deleteModal">❌</p>
      </div>
      <div>
        <p>آیا میخواهید حذف کنید!</p>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
          <button class="btn btn-primary btn-approve" @click="deleteItemForm(id_item)">تایید</button>
        </div>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div class="modal__error bg-white" style="z-index: 9999; direction: rtl; width: 54vw; overflow-y: scroll; height: 35vw;" v-show="documentsModal">
    <div class="d-flex justify-content-between">
      <p>{{titleDoc}}</p>
      <p id="btn2_p" @click.prevent="documentsModal=!documentsModal">❌</p>
    </div>
    <hr>
    <div class="d-flex flex-column" >
      <label class="required text-end">     عنوان مستندات پیوست  </label>
      <input id="title" v-model="title_attach" type="text" class="form-control">
    </div>
    <div class="d-flex flex-column" >
      <label class="required text-end">      فایل   پیوست  </label>
      <label class="input input--file">

        <input   id="file" type="file" class="input__field" accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .csv" required>
        <span class="input__support">
    <span class="input__helper"></span>
    </span>
      </label>
    </div>

    <div id="showBar" style="display:none;">
      <div class="progress">
        <div class="progress-bar" role="progressbar" id="progress_bar"  :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <p id="progress"></p>
    </div>
    <center class="my-2" >
      <button id="btn_p" @click="addDocs" class="btn btn-primary btn-submit-1">افزودن </button>
      <hr class="my-3 w-100" >
    </center>
    <div v-if="!documents.length">موردی یافت نشد!</div>
    <table  class="table table-striped bg-white" v-if="documents.length">
      <thead >
      <tr>
        <th ><strong> عنوان مستند    </strong></th>
        <th><strong>فایل مستند</strong></th>
        <th v-if="show_insert" style="width: 1vw;"><strong>عملیات  </strong></th>
      </tr>
      </thead>
      <tbody>

      <tr class="bg-white" v-for="(item) in documents">
        <td>{{item.text}}</td>
        <td>
          <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
        </td>
        <td v-if="show_insert">
          <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>

        </td>
      </tr>
      </tbody>


    </table>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="delete_fileModal=!delete_fileModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import {useToast} from "vue-toastification";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
const toast = useToast();

export default {
  components: {
    Reset,
    Sidebar,
    splash
  },
  data() {
    return {
      allItems: [],
      id_route: this.$route['params']['id'],
      allItemsOther: [],
      id_user: '',
      other_root: '',
      management_root: '',
      tech_root: '',
      money_root: '',
      is_human_root: '',
      type_root: '',
      title_root: '',
      id_root: '',
      modalSave: false,
      deleteModal: false,
      status_show: false,
      status_loading: false,
      infoCancelled: false,
      text_info: '',
      modalMessageShow: '',
      id_item: '',
      modalMessage: false,
      modalMessageShowModal: false,
      status_loading2: false,
      documents: [],
      documentsModal: false,
      title_attach: '',
      id_file: '',
      progress: '',
      delete_fileModal: false,
    }
  },
  methods: {
    exportDocs() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('company_id', this.id_route)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/rootCauses/export_doc`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.download_link) {
              // ایجاد یک المان a مخفی برای دانلود
              const link = document.createElement('a');
              link.href = response.download_link;
              link.download = 'documents.zip'; // یا هر نام دیگری که می‌خواهید
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              toast.info('دانلود شروع شد');
            } else if (response.error) {

              // نمایش پیام خطا به کاربر
              toast.error('خطا در دریافت فایل: ' + response.error);
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },
    deleteMethodFileSubmit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/rootCauses/remove_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message){
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    allDocsMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('company_id', this.id_route)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/all_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.documents.length=0
            response.all.forEach((item)=>{
              this.documents.push(item)
            })


          })
          .catch();
    },
    deleteMethodFile(id){
      this.id_file = id
      this.delete_fileModal = true
    },
    addDocs() {
      const token = this.$cookies.get('token')
      const id_item = this.id
      const url = this.base_url
      const file = document.querySelector('#file').files[0];
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('text', this.title_attach);
      formdata.append('file', file);
      formdata.append('id', this.id);
      formdata.append('company_id', this.id_route)

      var xhr = new XMLHttpRequest();
      xhr.open('POST', `${this.base_url}/rootCauses/add_doc`, true);

      // Listen to the progress event
      xhr.upload.onprogress = function(event) {
        if (event.lengthComputable) {
          document.getElementById("showBar").style.display = 'block';
          document.getElementById("btn2_p").style.visibility= 'hidden'
          document.getElementById("btn_p").style.visibility= 'hidden'
          var progress = ((event.loaded / event.total) * 100).toFixed();
          // Update progress UI here
          // For example:
          this.progress = progress
          document.getElementById("progress").innerText = `${progress}%`;
          document.getElementById("progress_bar").style.width = `${progress}%`;
        }
      };

      xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            // Handle successful upload
            var response = JSON.parse(xhr.responseText);
            if (response.error) {
              toast.error(response.error);
              ;

              document.getElementById("showBar").style.display = 'none';
              document.getElementById("btn2_p").style.visibility= 'visible'
              document.getElementById("btn_p").style.visibility= 'visible'
              return false;
            } else {
              toast.success(response.message);
              file.value = '';
              this.title_attach = '';
              document.querySelector('#title').value = ''
              document.querySelector('#file').value = ''
              document.getElementById("showBar").style.display = 'none';
              document.getElementById("btn2_p").style.visibility= 'visible'
              document.getElementById("btn_p").style.visibility= 'visible'

            }
          } else {
            // Handle upload error
            console.error('Upload error:', xhr.status);
          }
        }
      };

      // Set headers
      for (var pair of myHeaders.entries()) {
        xhr.setRequestHeader(pair[0], pair[1]);
      }

      // Send the request with form data
      xhr.send(formdata);
      this.allDocsMethod(this.id);
      this.title_attach = '';

    },
    AddDocumentMethod(id,title){
      this.documentsModal = true
      this.id = id
      this.allDocsMethod(id)
    },


    // *************************************
    // *************************************
    resetItems(){
      this.resetData()
      this.is_update = false
      this.id_item = ''
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('title', this.title_root)
      formdata.append('type',this.type_root)
      formdata.append('is_human', this.is_human_root===true ? 1 : 0)
      formdata.append('is_fund',this.money_root===true ? 1 : 0)
      formdata.append('is_technology', this.tech_root===true ? 1 : 0)
      formdata.append('is_management',this.management_root===true ? 1 : 0)
      formdata.append('other',this.other_root)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.resetItems()
            this.fetchOther(response.id)



          })
          .catch();

    },
    editMethod(id){
      this.is_update = true
      this.id_item = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const item = response.item


            this.is_update = true

            if (item){
              this.title_root = item.title
              this.type_root = item.type
              this.is_human_root = item.is_human ? true : false
              this.money_root = item.is_fund ? true : false
              this.tech_root = item.is_technology ? true : false
              this.management_root = item.is_management ? true : false
              this.other_root = item.other

            }
          })
          .catch();

    },
    deleteMethod(id){
      this.id_item = id
      this.deleteModal = true
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message){
              toast.success(response.message)
              this.fetchOther(response.id)
              this.id_item = ''
              this.deleteModal = false

            }
          })
          .catch();
    },
    acceptComplete(){
      if (this.status_show ){
        return;
      }
      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.status_show) {
          this.text_info = ''
          this.infoCancelled = true
          return;
        }
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
              this.infoCancelled = false

            }

          })
          .catch();
    },
    acceptComplete2(){

      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3(){
      this.status_loading2 = true
      if (!this.status_show){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info){
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/rootCauses/update_complete_by_mother/${this.id_route}`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    resetData(){
      this.other_root = ''
      this.management_root = 0
      this.tech_root = 0
      this.money_root = 0
      this.is_human_root = 0
      this.type_root = ''
      this.title_root = ''


    },
    modalSaveModal(id){
      this.resetData()
      this.modalSave= true
      this.id_root= id
      this.fetchOther(id)
    },
    fetchOther(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('company_id',this.id_route)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/all/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsOther.length = 0
            response.all.forEach((item) => {
              this.allItemsOther.push(item)

            })
          })
          .catch();
    },
    store_root(id){
      if (this.title_root.length===0){
        toast.error('عامل ریشه ای اجباری است!')
        return;
      }else if (this.type_root.length===0){
        toast.error('نوع اجباری است!')
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('causes_id', parseInt(id))
      formdata.append('title', this.title_root)
      formdata.append('type',this.type_root)
      formdata.append('is_human', this.is_human_root===true ? 1 : 0)
      formdata.append('is_fund',this.money_root===true ? 1 : 0)
      formdata.append('is_technology', this.tech_root===true ? 1 : 0)
      formdata.append('is_management',this.management_root===true ? 1 : 0)
      formdata.append('other',this.other_root)
      formdata.append('company_id',this.id_route)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.resetData()
            this.fetchOther(id)


          })
          .catch();
    },

    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {
              this.allItems.push(item)

            })
            if (response.message){
              this.modalMessage = true
              this.modalMessageShow = response.message
            }
          })
          .catch();
    },
    store(){
      let obj = []
      this.allItems.forEach((ele)=>{
        const method = document.getElementById(`method_${ele.id}`).value

        const item = {
          'id': ele.root_causes_problem ? ele.root_causes_problem.id : '',
          'prioritizing_issues_id': ele.id,
          'method': method,
        }
        obj.push(item)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('company_id',this.id_route)
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.all()

          })
          .catch();

    },
    checkIsMother() {
      if (!this.is_mother) {
        router.push('/pishkhan')
      }
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }


          })
          .catch();
    },


  },
  mounted() {
    this.all()
    this.fetchItems()
    this.checkIsMother()
  },
}
</script>
<style scoped lang="scss">
.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}

.input:hover .input__support {
  border-color: #9fa8b2;
}
.input:hover .input__support:before {
  color: #7d8a96;
}
.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}
.input__text sup {
  color: #fe4f3e;
  cursor: help;
}
.input .input__support:before {
  display: none;

}
.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__field:focus + .input__support {
  border-color: #037DE4;
}
.input__field:valid + .input__support {
  border-color: #3742FA;
}
.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}
.input__field:valid + .input__support .input__helper:before {
  content: "یک فایل انتخاب شده است";
  color: #7d8a96;
}
.input__field:invalid + .input__support:before {
  content: "file_upload";
}
.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}
.input__support {
  display: flex !important;
  align-items: center;
}
.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}
.input--file {
  cursor: pointer;
}
.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}
img:hover{
  border-radius: 50%;
}
</style>